"use client";

/**
 * NewForm DS hover icon — four corner brackets for "open full size".
 * On hover they push outward together, so the glyph acts out the frame
 * growing rather than just sitting there.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function ExpandIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-expand">
        <path d="M9.4 3.8H3.8v5.6" />
        <path d="M14.6 3.8h5.6v5.6" />
        <path d="M20.2 14.6v5.6h-5.6" />
        <path d="M3.8 14.6v5.6h5.6" />
      </g>
    </HoverIconSvg>
  );
}
